import React from 'react'
import { Affix, Button, Typography } from 'antd'
import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'

export interface IDefaultSubheaderProps {
  title: string
  isSticky?: boolean,
  whyThisMattersSlug?: string
  isStartingExercise?: boolean
  gotoWhyThisMatters: (slug: string) => void
}

const { Title } = Typography;

const SubheaderWrapper = styled.div`
  background: #EEEEEE;
  height: 100px;

  h2 {
    padding-top: 1.5rem;
    margin-bottom: 0;
    font-family: Poppins, sans-serif;
    font-weight: normal;
    font-size: 36px;
    text-transform: uppercase;
  }
`;

const DefaultSubheader = ({ title, isSticky, whyThisMattersSlug, isStartingExercise, gotoWhyThisMatters }: IDefaultSubheaderProps) => {
  const whyThisMatterButton = whyThisMattersSlug && isStartingExercise && (
    <Col lg={5}>
      <Button
        type="primary"
        className="float-right mt-4"
        onClick={() => gotoWhyThisMatters(whyThisMattersSlug)}
      >
        Why This Matters?
      </Button>
    </Col>
  )

  const content = (
    <SubheaderWrapper>
      <Container>
        <Row>
          <Col lg={7}>
            <Title level={2}>{title}</Title>
          </Col>
          {whyThisMatterButton}
        </Row>
      </Container>
    </SubheaderWrapper>
  )

  if (isSticky) {
    return (
      <Affix offsetTop={78}>
        {content}
      </Affix>
    )
  }

  return content
}


export { DefaultSubheader }